import React from 'react'
import UserTable from '../Table/userData/Table'

const UserInfo = (props:any) => {
  return (
    <UserTable {...props} />
  )
}

export default UserInfo